var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('feather-icon',{attrs:{"icon":"SaveIcon","svgClasses":"h-6 w-6 hover:text-primary cursor-pointer"},on:{"click":_vm.saveRecord}}),_c('feather-icon',{attrs:{"icon":"TrashIcon","svgClasses":"h-6 w-6 hover:text-primary cursor-pointer ml-3"},on:{"click":_vm.clearAlltenndeeScore}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }